import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-remove-item-warning',
  templateUrl: './remove-item-warning.component.html',
  styleUrls: ['./remove-item-warning.component.scss']
})
export class RemoveItemWarningComponent{
  constructor(
    public dialogRef: MatDialogRef<RemoveItemWarningComponent>
  ) { }
  onClose(val){
    this.dialogRef.close(val);
  }
}
